exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".richTextEditorFieldRenderer_richTextEditor__qf-sx{height:20rem;width:120%}[dir] .richTextEditorFieldRenderer_richTextEditor__qf-sx{border:.1rem solid #969aa3}", ""]);

// Exports
exports.locals = {
	"richTextEditor": "richTextEditorFieldRenderer_richTextEditor__qf-sx"
};